// extracted by mini-css-extract-plugin
module.exports = {"state":"#767676","bodyGray":"#4F4F4F"};